import React from "react";
import toast from "react-hot-toast";
import config, { getApiUrl } from "./config";
import authService from "./AuthService";
import {ReactComponent as CloseIcon} from "./close.svg";
import "./EventsView.css";

enum EventSeverity {
    INFO = "INFO",
    WARNING = "WARNING",
    ERROR = "ERROR",
    FATAL = "FATAL"
}

enum EventCategory {
    CLOUD = "CLOUD",
    HARDWARE = "HARDWARE",
    ENDPOINT = "ENDPOINT",
    APPLIANCE = "APPLIANCE",
    SERVICE = "SERVICE",
}

type Event = {
    time: number,
    source: string,
    severity: EventSeverity,
    category: EventCategory,
    title: string,
    description: string
}

type EventViewProps = {
    endpointId: string
}

type EventViewState = {
    events: Event[],
    selectedEvent: Event | undefined
    chunksRemaining: boolean
}

class EventView extends React.Component<EventViewProps, EventViewState> {
    constructor(props: EventViewProps) {
        super(props);
        this.state = {
            events: [],
            selectedEvent: undefined,
            chunksRemaining: true
        }
    }

    componentDidMount() {
        this.loadNextEventsChunk();
    }

    prependEvents(eventJson: string) {
        const newEvents = JSON.parse(eventJson) as Array<Event>;
        const events = newEvents.concat(this.state.events).sort((a, b) => b.time - a.time);
        this.setState({events: events});
    }

    private loadNextEventsChunk() {
        if (!this.state.chunksRemaining) return;

        let to = 'now()';
        if (this.state.events.length > 0) {
            to = Math.round(this.state.events[this.state.events.length - 1].time / 1000000000).toString();
        }
        console.log("Fetching events from " + to)

        fetch(getApiUrl() + `/v1/endpoint/${this.props.endpointId}/event/?limit=10&to=` + to, {
            method: "GET",
            headers: [
                ["Accept", "application/json"],
                ["Authorization", authService.authHeader()]
            ]
        })
            .then(res => {
                if (res.ok)
                    return res.json() as Promise<Event[]>;
                else
                    throw new Error("Failed to fetch events: " + res.status + " " + res.statusText);
            })
            .then((events) => {
                if (events.length < 10) {
                    this.setState({chunksRemaining: false})
                }
                this.setState({events: this.state.events.concat(events)});
            })
            .catch((error) => {
                toast.error("Failed to fetch events: " + error);
            });
    }

    private renderEvent(e: Event) {
        const date = new Date(e.time / 1000000);

        return <div key={"event-" + e.time} className="EventsView-event" onClick={() => {
            this.setState({selectedEvent: e})
        }}>
            <span className={"severity " + e.severity}/>
            <span
                className="time">{date.toLocaleDateString() + " " + date.toLocaleTimeString() + "." + ('000' + date.getMilliseconds()).substr(-3)}</span>
            <span className={"category " + e.category}/>
            <span className="source">{e.source}</span>
            <span className="title">{e.title}</span>
        </div>
    }

    private renderEventDetails(e: Event) {
        const date = new Date(e.time / 1000000);

        return <div className="EventsView-eventdetails">
            <div className="EventsView-eventdetails-content">
                <div className="EventsView-eventdetails-controls">
                    <span className={"severity " + e.severity}></span>
                    <div className="EventsView-eventdetails-title">{e.title}</div>
                    <span className="EventsView-eventdetails-spacer"/>
                    <button className="EventsView-eventdetails-close"
                            onClick={() => this.setState({selectedEvent: undefined})}><CloseIcon/></button>
                </div>
                <div>

                    <div className="source-row">
                        <div
                            className="time">{date.toLocaleDateString() + " " + date.toLocaleTimeString() + "." + ('000' + date.getMilliseconds()).substr(-3)}</div>
                        <span className={"category " + e.category}/>
                        <span className="source">{e.source}</span>
                    </div>
                    <div className="description">{e.description}</div>
                </div>
            </div>
        </div>
    }

    private renderEventsView() {
        return <div>
            <div className="EventsView">
                {this.state.events.map((e: Event) => {
                    return this.renderEvent(e);
                })}

            </div>
            <a className={"EventsView-fetch" + (this.state.chunksRemaining ? "" : " disabled")} onClick={() => {
                this.loadNextEventsChunk();
            }}>Load more events</a>
            {this.state.selectedEvent && this.renderEventDetails(this.state.selectedEvent)}
        </div>
    }

    render() {
        if (this.state.events.length > 0) {
            return this.renderEventsView();
        } else {
            return <div>
                <div className="EventsView-noevents">No events</div>
            </div>
        }
    }
}

export default EventView;